module.exports = __webpack_public_path__ + "img/9.cbba6a83.jpg";